// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { isString } from "@sequentech/ui-core";
export var sortFunction = function (a, b) {
    if (isString(a === null || a === void 0 ? void 0 : a.name) && isString(b === null || b === void 0 ? void 0 : b.name)) {
        return a.name.localeCompare(b.name);
    }
    return 0;
};
// Error codes emitted by sequent_core::services::tally_sheet_validation.
// The values must match the Rust side exactly.
export var VALIDATION_ERROR_CODES = {
    INVALID_TOTAL_VALID_VOTES: "invalid_total_valid_votes",
    TOTAL_VOTES_EXCEEDS_CENSUS: "total_votes_exceeds_census",
    INVALID_TOTAL_INVALID: "invalid_total_invalid",
    INVALID_TOTAL_VOTES: "invalid_total_votes",
    UNKNOWN_COUNTING_ALGORITHM: "unknown_counting_algorithm",
};
// Maps a shared tally sheet validation error's `code` (from
// sequent_core::services::tally_sheet_validation, used by both manual entry
// and tally sheet import) to the i18n key used to render it. Codes without
// an entry here fall back to `tallysheet.inputError.<code>`.
var VALIDATION_ERROR_TRANSLATION_KEYS = (_a = {},
    _a[VALIDATION_ERROR_CODES.INVALID_TOTAL_VALID_VOTES] = "tallysheet.inputError.totalValidDoesNotMatch",
    _a[VALIDATION_ERROR_CODES.TOTAL_VOTES_EXCEEDS_CENSUS] = "tallysheet.inputError.censusTooSmall",
    _a[VALIDATION_ERROR_CODES.INVALID_TOTAL_INVALID] = "tallysheet.inputError.totalInvalidDoesNotMatch",
    _a[VALIDATION_ERROR_CODES.INVALID_TOTAL_VOTES] = "tallysheet.inputError.totalVotesDoesNotMatch",
    _a[VALIDATION_ERROR_CODES.UNKNOWN_COUNTING_ALGORITHM] = "tallysheet.inputError.unknownCountingAlgorithm",
    _a);
// `t` is typed loosely (matching react-i18next's `useTranslation().t`)
// rather than importing i18next's TFunction, to avoid a new type
// dependency for a single helper.
export var translateSharedValidationError = function (t, error) {
    var _a, _b;
    var translationKey = (_a = VALIDATION_ERROR_TRANSLATION_KEYS[error.code]) !== null && _a !== void 0 ? _a : "tallysheet.inputError.".concat(error.code);
    return String(t(translationKey, __assign(__assign({}, ((_b = error.params) !== null && _b !== void 0 ? _b : {})), { defaultValue: error.message })));
};
